module.exports = __webpack_public_path__ + "static/JonathanGoforth-9783e654d9b86608ea13a7a52b00ec09.jpeg";